export const FORM_FIELDS_NAMES = {
 EMAIL:'email',
 PASSWORD: 'password',
 REMEMBER_ME: 'rememberMe',
 ENTER_NEW_PASSWORD: 'newPassword',
 CONFIRM_NEW_PASSWORD: 'confirmNewPassword',
}